




import { Vue, Component } from 'vue-property-decorator';

import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { OperationTypeWithoutBoth } from '@/componentsV2/organisms/LaunchRewardsProgramEmptyState/features';

import { EStartGuideTaskSlug } from '@/models/start-guide';

import eventBus from '@/utils/eventBus';
import {
  handleDispatchStartGuideHighlight,
  shouldAddSuccessStartGuide,
  taskIsComplete
} from '@/utils/start-guide';
import { ERewardsProgramStepSlug } from '../Modals/RewardsProgramModal/RewardsProgramModal.vue';

@Component({
  components: {}
})
export default class RewardsModel extends Vue {
  private get getBusinessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  async handleOperationSelect(operationType: OperationTypeWithoutBoth) {
    this.$store.dispatch('startGuide/UPDATE_PREFERENCES');
    this.$store.dispatch('startGuide/UPDATE_TASKS');
    this.$store.dispatch('startGuide/FILTER_TASKS_BY_OPERATION', operationType);
  }

  openRewardsProgramModal({
    operationType,
    initialStep,
    feature,
    ...rest
  }: {
    operationType: OperationTypeWithoutBoth;
    initialStep?: ERewardsProgramStepSlug;
    feature?: string;
  }) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'rewardsProgramModal',
        mobilePositionBottom: true,
        noBackground: true,
        mobileFullScreen: false
      }),
      {
        operationType,
        initialStep,
        feature,
        ...rest,
        onConfirm: async () => {
          if (shouldAddSuccessStartGuide(EStartGuideTaskSlug.REWARD_COINS)) {
            this.$store.dispatch('startGuide/ADD_SUCCESS_TASK');
          }

          if (taskIsComplete(EStartGuideTaskSlug.REWARD_COINS)) {
            this.handleOperationSelect(this.getBusinessInfo.operationType);
          }
          eventBus.$emit('rewardProgramSuccess');
          eventBus.$emit('closeModal');

          if (rest && (rest as any).showStartGuideHighlight) {
            handleDispatchStartGuideHighlight();
          }
        }
      }
    );
  }
}
